<script>
import { fetchParkigList } from "@/api/url";
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      parkingList: [],
      id: "",
    };
  },
  watch: {
    id: {
      handler:function(val){
        const currentParking = this.getCurrentParking(val);
        //存储状态
        this.setParking(currentParking);
      
    },
    immediate:true
    }
  },
  mounted() {
    this.getAllParkingLot();
  },
  methods: {
    ...mapActions("parking", ["setParking"]),
    getAllParkingLot() {
      this.$get(fetchParkigList()).then((data) => {
        if (data.status === 200) {
          this.parkingList = data.data;
        }
      });
    },
    getCurrentParking(value) {
      const parking = this.parkingList.find((item) => value === item.parkingId);
      if (parking) {
        return {
          parkingId: parking.parkingId,
          parkingName: parking.parkingName,
        };
      }
      return null;
    },
  },
  render() {
    return (
      <el-select
        class="check-parking"
        filterable
        clearable
        placeholder="请选择道路"
        v-model={this.id}
      >
        {this.parkingList.map((item) => (
          <el-option key={item.parkingId} value={item.parkingId} label={item.parkingName} />
        ))}
      </el-select>
    );
  },
};
</script>
<style>
</style>